export default {
  path: '/*',
  name: '404',
  component: () => import(/* webpackChunkName: 'App.404' */ '@/main/views/errors/404.vue'),
}
